import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/cylinder-volume-calculator',
  component: () => import('../../routes/CylinderVolumeCalculator.svelte'),
  card: {
    id: 'cylinder-volume-calculator',
    title: 'Cylinder Volume Calculator',
    description: 'Calculate the volume, surface area, and other properties of a right circular cylinder from radius and height.',
    icon: 'cylinder',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/cylinder-volume-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Cylinder Volume Calculator – Find Cylinder Volume & Surface Area',
    description: 'Free cylinder volume calculator. Calculate volume, curved surface area, total surface area, base area, circumference, and diameter from radius and height. Supports inches, feet, cm, m, mm, yards.',
  },
};

export default meta;